/**
 * 保存性别和生日时，服务端现在记的和这次填的对不上（真冲突）：两边并排写出来，等主人选（CREATE-PET-RED-01，I 10-09 裁定第 2 条）。
 * - 不写“家里有人”：可能就是主人自己在另一台设备上改的；
 * - 只写有差别的项（性别、出生日期、为 TA 选定的生日），说法和“TA 的档案”卡一致：性别“男孩 / 女孩 / 还不知道”，
 *   出生日期照服务端写法（这次填的还没存上，照同一套写法写，估计的写“约”），不知道写“不知道”，选定的生日没选写“没选”；
 * - 不出字段名、版本号、错误码。按钮由用的地方自己放（建宠页和档案卡都是“用这次填的”“保留现在的”）。
 */
import type { PetCoreFactsUpdate, PetCoreFactsView } from "@/shared/contracts";
import { factsDifferences } from "./factsModel";

export function FactsConflictLines({ stored, body }: { stored: PetCoreFactsView; body: PetCoreFactsUpdate }) {
  const lines = factsDifferences(stored, body);
  return (
    <>
      <p>TA 的档案刚刚有了别的修改，和这次填的不一样。</p>
      <p>现在记的是：{lines.map((line) => `${line.label} ${line.now}`).join("；")}</p>
      <p>这次填的是：{lines.map((line) => `${line.label} ${line.draft}`).join("；")}</p>
    </>
  );
}
